import { useEffect, useState } from "react";

/*
 * Хук для получения информации о том что window существует
 *
 * Важно:
 * 1. При hydration значение будет false
 * 2. Только после монтирования значение изменится на true
 */
export const useHasWindow = () => {
  const [hasWindow, setHasWindow] = useState(false);
  useEffect(() => {
    if (!hasWindow && typeof window !== "undefined") {
      setHasWindow(true);
    }
  }, [hasWindow]);

  return hasWindow;
};
